module.exports = __webpack_public_path__ + "img/inspiration@2x.b5eaa8a.jpg";